/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Autocomplete, Box, Grid2, IconButton, InputAdornment, MenuItem, TextField, ThemeProvider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { theme } from '../../../theme';
import HPIBack from '../../../assets/SVG/HPIBack.svg';
import { getDoctors, User } from '../../Diagnosis/diagnosisHelper';
import { DrugRouteMenuItems, fetchMedicalHistoryMasterData, getdrug, getRoute, initialPatientDrugsCreateValues, PatientDrugsCreate, PatientDrugsCreateValidationSchema, postdrug, PostPatientDrugs, putdrug, RouteData } from './DrugsHomeHelper';
import { usePatientContext } from '../../SubPatinetProvider';
import { usePatientContext as MainPatientContext } from '../../patinetProvider';
import { useAlert } from '../../alertProvider';
import { useLoader } from '../../loaderProvider/loader';
import { patientDetailsObservable } from '../../../services/sharedService';
import { Field, FieldArray, FieldProps, Form, Formik, FormikErrors } from 'formik';
import { RequiredLabel } from '../../../utils/commonUtils';
import { ConfirmationModal } from '../../confirmationModal';

import { DropdownOption, mapDropdownOptions } from '../../Medical_History_Forms/MenstrualHistory/MenstrualHistory.helpers';
import { ReactComponent as DeleteIcon } from '../../../assets/SVG/trash.svg';
import { ReactComponent as SearchIcon } from '../../../assets/SVG/Search-Icon.svg';

interface AddDrugsProps {
    onBackClick: () => void;
    data: any; // This is the prop you're passing (the selected data)
  }

const AddDrugs: React.FC<AddDrugsProps> = ({ onBackClick, data }) => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tTP } = useTranslation('treatmentPlan_config');

  const [inputValue, setInputValue] = useState(''); // State for input value
  const [drug, setdrug] = useState<any[]>([]);
  const [selecteddrug, setSelecteddrug] = useState(null);
  const [doctors, setDoctors] = useState<User[]>([]);
  const [initialValues, setInitialValues] = useState<{ drug: PatientDrugsCreate[] }>({ drug: [initialPatientDrugsCreateValues],  });
  const { patientId } = usePatientContext();
  const { MainpatientDetails } = MainPatientContext();
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false); 
  const [contentMessage , setcontentMessage]=useState('');
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const [patientDetails, setpatientDetails] = useState<any >(null);
  const [drugRoutes, setDrugRoutes] = useState<{ label: string; value: string }[]>([]);
  const [dropdownOptionsForDrugs, setDropdownOptionsForDrugs] = useState<{
    frequency: DropdownOption[];
    instructions: DropdownOption[];
   
  }>({
    frequency: [],
    instructions: [],
 
  });
  
  const Max_notes_LENGTH = 255;
  useEffect(() => {
    const subscription = patientDetailsObservable.subscribe((value) => {
      setpatientDetails(value);
    });
    
    return () => subscription.unsubscribe();
  }, []);
  
  useEffect(() => {
    try {
      getDoctors().then((res) => {
        setDoctors(res.objects);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch doctors:', error);
    }
  }, []);

  useEffect(() => {
    fetchMedicalHistoryMasterData(
      'drug_frequency,drug_instructions'
    )
      .then((response) => {
        setDropdownOptionsForDrugs({
          frequency: mapDropdownOptions(response?.drug_frequency),
          instructions: mapDropdownOptions(response?.drug_instructions),
         
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching medical history masters', err);
      });
  }, []);

  const handleSelectionChange = async (
    value: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<{ drug: PatientDrugsCreate[]; }>>,
    values: { drug: any[] }
  ) => {
    if (value) {
      const filtereddrug = values.drug.filter((drug) => drug.drug);
  
      const isDuplicate = filtereddrug.some((drug) => drug.drug === value.id);
  
      if (isDuplicate) {
        addAlert(tTP('drugAlreadyAdded'), 'info');
        return;
      }

      // Get default doctor from appointment if available
      const defaultDoctorId = MainpatientDetails?.appointment_doctor?.id || null;
  
      await setFieldValue('drug', [
        ...filtereddrug,
        {
          patient: patientId,
          drug: value.id,
          drug_name: value.molecule_label || value.molecule,
          drug_brandName: value.name,
          drug_UOM:value.base_uom,
          strength_type:value.strength_type,
          drug_strength:value.strength,
          frequency: value.frequency,
          available_stock: value.available_stock ?? null,

          instructions: null, 
          no_of_days: null, 
          quantity: null, 
          notes: '', 
          user: defaultDoctorId, 
          drug_route: value.route,
        },
      ]);
    }
  };
  
  

  const onBack = () => {
    onBackClick();
  };

  const handleSearch = (searchValue: string) => {
    
    if (searchValue.length>0) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        const query = `?search=${searchValue}&is_drug=true`;
        getdrug(query).then((res) => {
          setdrug(res.objects);
        });
      }, 300);
    }
  };

  const handleSubmit = (values: any, { setSubmitting, resetForm }: any) => {
    showLoader();
    const convertedData:PostPatientDrugs[] = values.drug.map((test:any) => {
      
      return {
        patient: test.patient,       
        drug: test.drug,   
        frequency: test.frequency,         
        instructions: test.instructions,  
        no_of_days:test.no_of_days,
        quantity:test.quantity,
        notes: test.notes || '',
        drug_route:test.drug_route || '',
        user:  test.user,
      };
    });
    
    if (data) {
      Promise.all(convertedData.map(drugs => putdrug(`${data.id}/`, drugs)))
        .then(() => {
          addAlert(tTP('drugUpdatedSuccessfully'), 'success');
          onBackClick();
        
        })
        .catch((error) => {
        // eslint-disable-next-line no-console
          console.error('An error occurred:', error);
          addAlert(tTP('errorUpdatingDrug'), 'error');
        })
        .finally(()=>{
          hideLoader();
        });
    } else {
      Promise.all(convertedData.map(data => postdrug(data)))
        .then(() => {
          addAlert(tTP('drugAddedSuccessfully'), 'success');
          onBackClick();
        
        })
        .catch((error) => {
        // eslint-disable-next-line no-console
          console.error('An error occurred:', error);
          addAlert(tTP('errorSavingDrug'), 'error');
        })
        .finally(()=>{
          hideLoader();
        });
    }
    
    
  };
  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };
  useEffect(() => {
    if (data) {
      const doctor = doctors.find(doc => doc.first_name === data.user_first_name);
      setInitialValues({
        drug: [{
          id: data.id,
          drug: data.drug.id, 
          drug_name: data.drug.molecule_label || data.drug.molecule,
          drug_brandName: data.drug.brand_name,
          drug_strength: data.drug.strength,
          drug_UOM: data.drug.base_uom_code,
          strength_type: data.drug.strength_type,

          frequency: data.frequency, 

          instructions: data.instructions,
          no_of_days: data.no_of_days, 
          quantity: data.quantity, 
          notes: data.notes, 
          user: doctor ? doctor.id : null, 
          patient: data.patient, 
          drug_route: data.drug_route_code, 
        }],
      });
    }
  }, [data, patientId, doctors]);

  const [missingFields, setMissingFields] = useState<{ [index: number]: string[] }>({});

  const handleOpenModal = (values: any) => {

    let allFieldsFilled = true;
    const updatedMissingFields: { [index: number]: string[] } = {};
    if (Array.isArray(values.drug)) {
      values.drug.forEach((row: any, index: number) => {
        const missingFields: string[] = [];
    
        if (!row.drug_name) missingFields.push('drug_name');
        if (!row.drug_brandName) missingFields.push('drug_brandName');
        if (!row.frequency) missingFields.push('frequency');
        if (!row.instructions) missingFields.push('instructions');
        if (!row.quantity) missingFields.push('quantity');
        if (!row.no_of_days) missingFields.push('no_of_days');
        if (!row.user) missingFields.push('user');
        if (!row.drug_route) missingFields.push('drug_route');
        if (missingFields.length > 0) {
          updatedMissingFields[index] = missingFields;
          allFieldsFilled = false;
        }
      });
    } else {
      // eslint-disable-next-line no-console
      console.error('values.drug is undefined or not an array');
      allFieldsFilled = false;
    }
    setMissingFields(updatedMissingFields);
  
    if (allFieldsFilled) {
      if (data) {
        setcontentMessage(tTP('confirmUpdateDrugOrder'));
      } else {
        setcontentMessage(tTP('confirmPlaceDrugOrder'));
      }
      setOpenConfirmDialog(true);
      
    }
  };
  
  useEffect(() => {
    getRoute()
      .then((response) => {
        setDrugRoutes(
          response?.objects.map((route: RouteData) => ({
            label: route.description, 
            value: route.code,       
          }))
        );
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching routes:', error);
      });
  }, []);
    
  const calculateQuantity = (frequency: string | null, days?: number | null): number => {
    if (!frequency || !days) return 0;
  
    // Convert "1/2" to 0.5, split numbers by "-"
    const doses = frequency.split('-').map((dose) => (dose === '1/2' ? 0.5 : parseInt(dose, 10) || 0));
  
    // Sum up the doses in a day
    const totalPerDay = doses.reduce((sum, val) => sum + val, 0);
  
    // Multiply by the number of days
    return totalPerDay * days;
  };

  const disabledFieldStyle = {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fbfbfb',
      '& input.Mui-disabled': {
        WebkitTextFillColor: '#444',
      },
      '&.Mui-disabled fieldset': {
        borderColor: '#ccc',
      },
      '&.Mui-error': {
        '& fieldset': {
          borderColor: 'red',
        },
      },
    },
  };
  
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true} 
      validationSchema={PatientDrugsCreateValidationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        handleSubmit,
        handleChange,
        handleBlur,
        setFieldValue,
        isSubmitting,
        dirty,
        touched,
        errors,
        setFieldTouched,
        submitForm,
        validateForm,
      }) => {
        return (
          <>
            <ThemeProvider theme={{theme}}>
              <div>
                <Grid2 container spacing={2}>
                  <Grid2 size={5} display="flex" justifyContent="start">
                    <IconButton onClick={onBack}>
                      <img src={HPIBack} alt="Back" style={{ width: '2.5rem', height: '2.5rem' }} />
                    </IconButton>
                  </Grid2>
                </Grid2>
              </div>
              <Form  onSubmit={(e) => {
                e.preventDefault();
              }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid2 container spacing={2}>
                    <Grid2 size={7}> {/* Occupies 6 out of 12 columns */}
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start', // Aligns to the start
                          marginBottom: 5,
                        }}
                      >
                        {!data && (
                          <Autocomplete
                            disablePortal
                            fullWidth
                            disabled={data}
                            options={inputValue.trim() ? drug : []}
                            open={drug.length > 0 && inputValue.length > 0}
                            value={selecteddrug}
                            inputValue={inputValue}
                            onChange={(e, value) => {
                              handleSelectionChange(value, setFieldValue, values);
                              setTimeout(() => setInputValue(''), 0);
                            }}
                            onInputChange={(e, value) => {
                              setInputValue(value);
                              handleSearch(value);
                            }}
                            getOptionLabel={(option) =>
                              typeof option === 'string' ? option : option.name || ''
                            }
                            filterOptions={(options, state) =>
                              options.filter((option) => {
                                const search = state.inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(search) ||
                                option.molecule?.toLowerCase().includes(search)
                                );
                              })
                            }
                            renderOption={(props, option) => {
                              const name = option?.name || option?.name_label || option?.brand_name || '';
                              const molecule = option?.molecule_label || option?.molecule;
                              const available = option.available_stock ?? null;

                              const showAvailability = available != null;
                              const isZeroStock = available === 0;
                              const badgeBgColor = isZeroStock ? '#FFEBEE' : '#EDF8EF';
                              const badgeTextColor = isZeroStock ? '#d32f2f' : '#47B35F';

                              return (
                                <li
                                  {...props}
                                  style={{
                                    ...(props?.style || {}),
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    paddingTop: 8,
                                    paddingBottom: 8,
                                  }}
                                  onMouseEnter={(e) => {
                                    const badge = e.currentTarget.querySelector('.avl-badge') as HTMLElement;
                                    if (badge) badge.style.backgroundColor = 'white';
                                  }}
                                  onMouseLeave={(e) => {
                                    const badge = e.currentTarget.querySelector('.avl-badge') as HTMLElement;
                                    if (badge) badge.style.backgroundColor = isZeroStock ? '#FFEBEE' : '#EDF8EF';
                                  }}
                                  onFocus={(e) => {
                                    const badge = e.currentTarget.querySelector('.avl-badge') as HTMLElement;
                                    if (badge) badge.style.backgroundColor = 'white';
                                  }}
                                  onBlur={(e) => {
                                    const badge = e.currentTarget.querySelector('.avl-badge') as HTMLElement;
                                    if (badge) badge.style.backgroundColor = isZeroStock ? '#FFEBEE' : '#EDF8EF';
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>
                                    {name} {molecule && `(${molecule})`}
                                  </div>
                                  {showAvailability && (
                                    <div className="avl-badge" style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, backgroundColor: badgeBgColor, padding: '4px 12px', borderRadius: 12, transition: 'background-color 0.2s ease' }}>
                                      <span style={{ color: badgeTextColor, fontWeight: 600, fontSize: 13 }}>{`${tTP('availableQty')} - ${available}`}</span>
                                    </div>
                                  )}
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={tTP('searchMedicinePlaceholder')}
                                slotProps={{
                                  input: {
                                    ...params.InputProps,
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon />
                                      </InputAdornment>
                                    ),
                                    style: data ? { cursor: 'not-allowed' } : undefined,
                                  },
                                  htmlInput: {
                                    ...params.inputProps,
                                    readOnly: data, // prevent typing if disabled
                                  }
                                }}
                                helperText={data ? tTP('searchNotAllowedAtEdit') : ''}
                                
                              />
                            )}
                            noOptionsText={
                              inputValue.trim() && drug.length === 0
                                ? tTP('noRelatedOptionForSearch')
                                : ''
                            }
                          />
                        )}
                      </Box>
                    </Grid2>
                  </Grid2>
                  {/* Dynamic Fields for Diagnoses */}
                  <FieldArray
                    name="drug"
                    render={({ remove }) => (
                      <>
                        {values.drug.map((row, index) => (
                          <Grid2 container spacing={2} marginBottom={3} key={index} alignItems="flex-start">

                            
                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <TextField
                                value={row.drug_brandName !== null ? row.drug_brandName  : ''}
                                variant="outlined"
                                name='drug_brandName'
                                size="small"
                                fullWidth
                                disabled
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label={RequiredLabel(tGeneral('drugName'), true)}
                                error={!!missingFields[index]?.includes('drug_brandName') && !row.drug_brandName} 
                                sx={disabledFieldStyle}
                              />

                            </Grid2>
                           
                            <Grid2 size={{xl:2, lg:3, md:4}}>
                      
                              <TextField
                                value={row.drug_name !== null ? row.drug_name  : ''}
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label={RequiredLabel(tGeneral('genericName'), true)}
                                error={!!missingFields[index]?.includes('drug_name') && !row.drug_name}
                                sx={disabledFieldStyle}

                              />

                            </Grid2>
                            <Grid2 size={{xl:2, lg:3, md:4}}>

                              <TextField
                                value={row.drug_strength !== null ? row.drug_strength  : null}
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                                InputLabelProps={{ shrink: row.drug_brandName ? true: false }}
                                label={RequiredLabel(tGeneral('strength'), false)}
                                error={!!missingFields[index]?.includes('drug_strength') && !row.drug_strength} 
                                sx={disabledFieldStyle}

                              />
  
                            </Grid2>
                            <Grid2 size={{xl:2, lg:3, md:4}}>

                              <TextField
                                value={row.strength_type !== null ? row.strength_type  : ''}
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                                
                                label={RequiredLabel(tGeneral('strengthType'), false)}
                                error={!!missingFields[index]?.includes('strength_type') && !row.strength_type} 
                                sx={disabledFieldStyle}

                              />
                           
                            </Grid2>

                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <Field
                                name={`drug[${index}].drug_route`}
                                render={({ field }: FieldProps) => (
                                  <Autocomplete
                                    options={drugRoutes} // Dynamically fetched options
                                    getOptionLabel={(option) => option.label}
                                    value={drugRoutes.find((item) => item.value === row?.drug_route) || null}
                                    onChange={(event, newValue) => {
                                      setFieldValue(`drug[${index}].drug_route`, newValue ? newValue.value : '');
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        {...field}
                                        label={RequiredLabel(tGeneral('route'), true)}
                                        variant="outlined"
                                        
                                        size="small"
                                        fullWidth
                                        error={!!missingFields[index]?.includes('drug_route') && !row.drug_route}
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            '&.Mui-error': {
                                              '& fieldset': {
                                                borderColor: 'red',
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />
                            </Grid2>                            
                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <Field
                                name={`drug[${index}].frequency`}
                                render={({ field }: FieldProps) => (
                                  <Autocomplete
                                    options={dropdownOptionsForDrugs.frequency}
                                    getOptionLabel={(option) => option.label}
                                    value={dropdownOptionsForDrugs.frequency.find((item) => item.value === row.frequency) || null}
                                    onChange={(event, newValue) => {
                                      const selectedFrequency = newValue ? newValue.value : '';
                                      setFieldValue(`drug[${index}].frequency`, selectedFrequency);
                            
                                      // Recalculate quantity when frequency changes
                                      const calculatedQty = calculateQuantity(selectedFrequency, row.no_of_days);
                                      setFieldValue(`drug[${index}].quantity`, calculatedQty);
                                    }}


                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        {...field}
                                        label={RequiredLabel(tGeneral('frequency'), true)}
                                        variant="outlined"
                                        
                                        size="small"
                                        fullWidth
                                        error={!!missingFields[index]?.includes('frequency') && !row.frequency}
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            '&.Mui-error': {
                                              '& fieldset': {
                                                borderColor: 'red',
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />

                            </Grid2>
                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <Field
                                name={`drug[${index}].instructions`}
                                render={({ field }: FieldProps) => (
                                  <Autocomplete
                                    options={dropdownOptionsForDrugs.instructions}
                                    getOptionLabel={(option) => option.label} // Map the options to their labels
                                    value={dropdownOptionsForDrugs?.instructions?.find((item) => item.value === row.instructions) || null}
                                    onChange={(event, newValue) => {
                                      setFieldValue(`drug[${index}].instructions`, newValue ? newValue.value : '');
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        {...field}
                                        label={RequiredLabel(tGeneral('instructions'), true)}
                                        variant="outlined"
                                        
                                        size="small"
                                        fullWidth
                                        error={!!missingFields[index]?.includes('instructions') && !row.instructions}
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            '&.Mui-error': {
                                              '& fieldset': {
                                                borderColor: 'red',
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />

                            </Grid2>
                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <Field
                                name={`drug[${index}].no_of_days`}
                                as={TextField}
                                label={RequiredLabel(tGeneral('days'), true)}

                                type="number"
                                variant="outlined"
                                fullWidth
                                
                                size="small"
                                value={row.no_of_days !== null ? row.no_of_days : ''}
                                error={!!missingFields[index]?.includes('no_of_days')&& !row.no_of_days} 
                                onKeyUp={(e:any) => {
                                  const days = e.target.value ? parseInt(e.target.value, 10) : 0;
                                  setFieldValue(`drug[${index}].no_of_days`, days);
                            
                                  // Recalculate quantity when days change
                                  const calculatedQty = calculateQuantity(row.frequency, days);
                                  setFieldValue(`drug[${index}].quantity`, calculatedQty);
                                }}
                              />
                            </Grid2>

                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <Box sx={{ width: '100%' }}>
                                <Field
                                  name={`drug[${index}].quantity`}
                                  as={TextField}
                                  label={RequiredLabel(tGeneral('qty'), true)}
                                  type="number"
                                  variant="outlined"
                                  fullWidth
                                  
                                  size="small"
                                  value={row.quantity !== null ? row.quantity : ''}
                                  error={!!missingFields[index]?.includes('quantity')&& !row.quantity} 

                                />
                                {row.available_stock != null && row.quantity !== null && row.quantity > row.available_stock && (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: '#ff9800',
                                      display: 'block',
                                      mt: 0.5,
                                      ml: 0.5,
                                      fontSize: '0.75rem',
                                      fontWeight: 500
                                    }}
                                  >
                                    {tTP('insufficientStock')} {row.available_stock})
                                  </Typography>
                                )}
                              </Box>
                            </Grid2>
                            <Grid2 size={{xl:2, lg:3, md:4}}>

                              <TextField
                                value={row.drug_UOM !== null ? row.drug_UOM  : ''}
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                                
                                label={RequiredLabel(tGeneral('UOM'), false)}
                                error={!!missingFields[index]?.includes('drug_UOM') && !row.drug_UOM} 
                                sx={disabledFieldStyle}

                              />
                           
                            </Grid2>


                           

                            <Grid2 size={{xl:2, lg:3, md:4}}>
                              <Field
                                name={`drug[${index}].user`}
                                render={({ field }: FieldProps) => (
                                  <Autocomplete
                                    options={doctors}
                                    getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                                    value={doctors.find((doctor) => doctor.id === row.user) || null}
                                    onChange={(event, newValue) => {
                                      setFieldValue(`drug[${index}].user`, newValue ? newValue.id : '');
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        {...field}
                                        label={RequiredLabel(tGeneral('doctor'), true)}
                                        variant="outlined"
                                        
                                        size="small"
                                        fullWidth
                                        error={!!missingFields[index]?.includes('user') && !row.user}
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            '&.Mui-error': {
                                              '& fieldset': {
                                                borderColor: 'red',
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />

                            </Grid2>
                            <Grid2 size={{xl:1.5, lg:2.5, md:3.5}}>
                              <TextField
                                name={`drug[${index}].notes`}
                                label={tGeneral('notes')}
                                variant="outlined"
                                fullWidth
                                size="small"
                                value={row.notes !== null ? row.notes : ''}
                                onChange={(e) => setFieldValue(`drug[${index}].notes`, e.target.value)}
                                inputProps={{ maxLength: Max_notes_LENGTH }}
                                multiline
                              />
                            </Grid2>
                            <Grid2 size={{xl:0.5, lg:0.5, md:0.5}} sx={{ display: 'flex', justifyContent: 'flex-end'}}>
                              <IconButton  onClick={() => {
                                if (values.drug.length === 1 && values.drug[index]?.drug_brandName) {
                                  setFieldValue('drug', [
                                    {
                                      patient: patientId,
                                      drug: null,
                                      drug_name: null,
                                      drug_brandName: null,
                                      drug_UOM:null,
                                      drug_strength:null,
                                      frequency: '',
                                      strength_type: null,
                            
                                      instructions: null, 
                                      no_of_days: null, 
                                      quantity: null, 
                                      notes: '', 
                                      user: null, 
                                      drug_route: null,
                                    },
                                  ]);
                                } else if (values.drug.length > 1) {
                                  remove(index);
                                } else {
                                  addAlert(tTP('atLeastOneDrugRecordMustRemain'), 'warning');
                                }
                              }}
                              disabled={data}
                              color="error"
                              sx={{ textTransform: 'none' }}>
                                <DeleteIcon />
                              </IconButton>
                            </Grid2>

                            {index < values.drug.length - 1 && (
                              <Grid2 size={12}>
                                <hr />
                              </Grid2>
                            )}
                          </Grid2>
                          
                        ))}
                      </>
                    )} /> 
                </Box>
                {/* Submit Button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                  <button
                    onClick={() => handleOpenModal(values)}
                    style={{
                      padding: '8px 10px',
                      border: 'none',
                      borderRadius: '7px',
                      fontSize: '16px',
                      fontWeight: '700',
                      backgroundColor:'#505050',
                      color:'#FFFFFF',
                      width: '130px'
                    }}
                  >
                    {data ? tTP('updateDrugOrder') : tTP('placeDrugOrder')}
                  </button>
                </Box>
              </Form>
              <ConfirmationModal
                open={openConfirmDialog}
                handleClose={handleCloseConfirmDialog}
                onConfirm={() => {
                  handleSubmit();
                }}
                type="save"
                title={data ? tTP('updateDrugOrder') : tTP('placeDrugOrder')}
                contentMessage={contentMessage}
              />
            </ThemeProvider></>
        );
      }}
    </Formik>
  );

};

export default AddDrugs;